import { Box, Modal } from "@mui/material";
import {
  ArrowRight,
  ChevronRight,
  Filter,
  LoaderCircle,
  X,
} from "lucide-react";
import { useLocation, useNavigate } from "react-router";
import SearchInput from "@components/ui/searchInput";
import TriggerEvents from "./triggerEvents";
import { Menu } from "@assets/mocks/filterData";
import React, { Dispatch, SetStateAction, useState } from "react";
import SoftwareSystems from "./softwareSystems";
import CompanySearch from "./companyFilters/companySearch";
import WebsiteContent from "./companyFilters/websiteContent";
import KeywordsAndTopics from "./companyFilters/keywordsAndTopics";
import CompanyProfile from "./companyFilters/companyProfile";
import Industries from "./industries";
import CompanyFilters from "./companyFilters";
import ContactFilters from "./contactFilters";
import RegionalFilters from "./regionalFilters";
import CompanySize from "./companyFilters/companySize";
import FinancialFigures from "./financialFigures";
import CountryFilter from "./regionalFilters/countryFilter";
import RadiusFilter from "./regionalFilters/radiusFilter";
import ContactProfile from "./contactFilters/contactProfile";
import ContactLocation from "./contactFilters/contactLocation";
import DepartmentAndHierarchy from "./contactFilters/departmentAndHierarchy";
import JobTitleSearch from "./contactFilters/jobTitleSearch";
import IndustryFilters from "./industries/industryFilter";
import WZIndustryFilters from "./industries/wz";
import NACEIndustryFilters from "./industries/nace";
import Favourites from "./favourites";
import FiltersForLists from "./filtersForLists";
import { Button } from "@components/ui/button";
import { IoAdd } from "react-icons/io5";
import { clearFilters, saveFiltersState } from "@redux/slices/filter";
import { RootState } from "@redux/store";

import { useDispatch, useSelector } from "react-redux";
import useAuth from "@hooks/useAuth";
import { Input } from "@components/ui/input";
import SoftwareSystemsData from "./softwareSystems/SoftwareDetail";
import TriggerEventsDetail from "./triggerEvents/TriggerEventsDetail";

import {useRecoilState } from "recoil";
import { FilterAtom } from "@/App";
interface Props {
  showModal: boolean;
  handleCloseModal: () => void;
  setCloseModal: Dispatch<SetStateAction<boolean>>;
}

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 990,
  height: 560,
  borderRadius: "6px",
  backgroundColor: "#F4F4F4",
  color: "#3F3F46",
  // p: 4,
};

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const DashboardFilters: React.FC<Props> = ({
  showModal,
  handleCloseModal,
  setCloseModal,
}) => {
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const navigate = useNavigate();
  let query = useQuery();
  const dispatch = useDispatch();
  const { user, logout } = useAuth();

  
  const data = useSelector((state: RootState) => state.filter);
  // dispatch(clearFilters(data));
  // console.log("I a printing data")
  // console.log(data)


  const handleClose = () => {
    handleCloseModal();
    navigate(`/targetMarkets/${user?.role}`);
  };

  const handleClearData = () => {
    dispatch(clearFilters(data));
  };
  const [filter, setFilter] = useRecoilState(FilterAtom);

  const addTargetMarket = () => {
    setLoading(true);
    saveFiltersState(user?.id, data, name, handleClearData);
    // clearFilters();
    setCloseModal(true);
    handleClose();
    setFilter([])
  };
console.log("hey i am didi")
  const renderContent = () => {

    console.log("Daraa"+query.get("filter"))
    switch (query.get("filter")) {
      // case "favourites":
      //   return <Favourites handleClose={handleClose} />;
      case "triggerEventsData":
        return <TriggerEventsDetail handleClose={handleClose} />;
      case "softwareSystemsDetail":
        return <SoftwareSystemsData handleClose={handleClose} />;
      case "companySize":
        return <CompanySize handleClose={handleClose} />;
      case "companySearch":
        return <CompanySearch handleClose={handleClose} />;
      case "websiteContent":
        return <WebsiteContent handleClose={handleClose} />;
      case "keywordsAndTopics":
        return <KeywordsAndTopics handleClose={handleClose} />;
      case "companyProfileCompleteness":
        return <CompanyProfile handleClose={handleClose} />;
      case "financialFigures":
        return <FinancialFigures handleClose={handleClose} />;
      case "countryFilters":
        return <CountryFilter handleClose={handleClose} />;
      case "radius":
        return <RadiusFilter handleClose={handleClose} />;
      case "contactProfileCompleteness":
        return <ContactProfile handleClose={handleClose} />;
      case "contactLocation":
        return <ContactLocation handleClose={handleClose} />;
      case "departmentHierarchy":
        return <DepartmentAndHierarchy handleClose={handleClose} />;
      case "jobTitleSearch":
        return <JobTitleSearch handleClose={handleClose} />;
      case "industry":
        return <IndustryFilters handleClose={handleClose} />;
      case "industryWZ":
        return <WZIndustryFilters handleClose={handleClose} />;
      case "industryNACE":
        return <NACEIndustryFilters handleClose={handleClose} />;
      case "filtersForLists":
        return <FiltersForLists handleClose={handleClose} />;
      default:
        return (
          <div className="p-8">
            <div className="flex justify-between items-center mb-5">
              <h4 className="text-xl font-bold flex items-center">
                <Filter size={22} className="me-3" />
                Select Filter
              </h4>
              <div className="flex items-center">
                <div className="me-4 flex items-center">
                  {/* <SearchInput /> */}
                  <p className="me-2">Name: </p>
                  <Input
                    placeholder="Target Market"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>
                <div className="flex justify-end me-4">
                  <Button onClick={addTargetMarket} className="bg-[#1CB5AF]">
                    {loading ? (
                      <LoaderCircle className="h-6 w-6 text-white animate-spin me-2" />
                    ) : (
                      <IoAdd size={20} className="me-2" />
                    )}
                    Add Target Market
                  </Button>
                </div>
                <X onClick={() => { handleClose(); setFilter([]); }} className="cursor-pointer" />
              </div>
            </div>

            <div className="flex gap-5">
              <div
                className="px-8 py-5 rounded-lg w-1/3 bg-white"
                style={{ boxShadow: "0px 10px 60px 0px #E2ECF980" }}
              >
                {Menu.map((val, index) => {
                  return (
                    <>
                      <div
                        className={`flex justify-between items-center font-medium cursor-pointer hover:text-[#1CB5AF] ${
                          val.path === query.get("filter")
                            ? "text-[#1CB5AF]"
                            : "text-[#71717A]"
                        } ${index > 0 && "pt-4"} ${
                          index < Menu?.length - 1 &&
                          "border-[1px] border-x-0 border-t-0 border-[#DBDBDB] pb-3"
                        }`}
                        onClick={() =>
                          navigate(
                            `/targetMarkets/${user?.role}/?filter=${val.path}`
                          )
                        }
                      >
                        <h6>{val.title}</h6>
                        <ChevronRight />
                      </div>
                    </>
                  );
                })}
              </div>
              {query.get("filter") === "industries" ? (
                <Industries />
              ) : query.get("filter") === "contactFilters" ? (
                <ContactFilters />
              ) : query.get("filter") === "regionalFilters" ? (
                <RegionalFilters />
              ) : query.get("filter") === "companyFilters" ? (
                <CompanyFilters />
              ) : query.get("filter") === "softwareSystems" ? (
                <SoftwareSystems />
              ) : query.get("filter") === "triggerEvents" ? (
                <TriggerEvents />
              ) :(
                <Favourites />
              )}
            </div>
          </div>
        );
    }
  };

  return (
    <Modal
      open={showModal}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>{renderContent()}</Box>
    </Modal>
  );
};

export default DashboardFilters;
